<template>
<v-container class="mt-8">

  <v-speed-dial top fixed>
        <template v-slot:activator>
            <v-btn color="white" dark fab :to="{name: 'Perfil'}">
                <v-icon color="primary">
                    mdi-keyboard-backspace
                </v-icon>
            </v-btn>
        </template>
    </v-speed-dial>

    <v-row
    class="text-center mt-10"
  >
    <v-col cols="12">
      <h2 class="mb-4" style="color:#1976D2;">Código QR</h2>
      <qrcode-vue
      :value="qr"
      :size="240"
      level="M"
      :background="'#f9f9f9'"
      :foreground="'#555555'"
      />

      <h3 class="mt-4" style="color:#555555;">Ya puedes mostrar tu código QR!</h3>
    </v-col>
  </v-row>

    <Alerta v-if="respuestaAlerta"  :parametros="parametros" />
    <Loader v-if="cargar"           :loader="loader" />

</v-container>
</template>

<script>
import QrcodeVue from 'qrcode.vue'

// importar librerías
import { mapGetters } from 'vuex'

// Componentes
import Alerta from '@/components/alertas/Alerta.vue'
import Loader from '@/components/alertas/Loader.vue'

export default {

    components: {
        Alerta,
        Loader,
        QrcodeVue
    },

    data: () => ({
        //Alertas
        respuestaAlerta: false,
        loader: true,
        cargar: false,

        parametros: {
            dialogError: false,
            mensaje: '',
            color: ''
        },

        qr: ''
    }),

    computed: {
        ...mapGetters('login', ['getGrupo', 'getUsuarioLMS', 'getDatosUsuarioLMS']),
    },

    async created() {

      const fechahora = new Date().toISOString()

      this.qr = JSON.stringify( this.getUsuarioLMS.iderp )
      /*JSON.stringify({
        id_alumno:
        this.getUsuarioLMS.iderp
      )*/
    },

    methods: {

        validarSuccess(mensaje) {
            this.cargar = false
            this.parametros.mensaje = mensaje
            this.parametros.dialogError = true
            this.parametros.color = 'success'
            this.respuestaAlerta = true
        },

        validarError(value) {
            this.cargar = false
            if (value.status == 400 || value.status == 500) {
                this.parametros.mensaje = value.body.message
                this.parametros.dialogError = true
                this.parametros.color = '#FF2C2C'
                this.respuestaAlerta = true
            }
        },

        validarErrorDirecto(mensaje) {
            this.cargar = false
            this.parametros.mensaje = mensaje
            this.parametros.dialogError = true
            this.parametros.color = '#FF2C2C'
            this.respuestaAlerta = true
        },

    },

}
</script>

<style scoped>
.cardShow {
    border-radius: 15px !important;
    box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.2) !important;
}

.colorCurso {
    color: #006093;
}
</style>
